var render = function render(){var _vm=this,_c=_vm._self._c;return _c('swiper',{staticClass:"partner-swiper",attrs:{"options":_vm.swiperOption}},[_c('swiper-slide',{staticClass:"partner-swiper-item"},[_c('img',{attrs:{"src":require("@/assets/img/panter-img.png")}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }